import * as generic from "@/store/generic/mutations/result-status.js";

export function clearError(state, payload) {
  generic.clearError(state, payload);
}

export function setError(state, payload) {
  generic.setError(state, payload);
}

export function setSuccess(state, payload) {
  generic.setSuccess(state, payload);
}

export function setProcessing(state, payload) {
  generic.setProcessing(state, payload);
}

export function setClassRoomsOwned(state, payload) {
  state.classRoomsOwned = payload ? payload : [];
}

export function setClassRoomOwned(state, payload) {
  state.classRoomOwned = payload;
}

export function setAvailableClassRoomsOwned(state, payload) {
  state.availableClassRoomsOwned = payload ? payload : [];
}

